import { render, staticRenderFns } from "./SelectCompanyProductAttribute.vue?vue&type=template&id=144d3871&"
import script from "./SelectCompanyProductAttribute.vue?vue&type=script&lang=js&"
export * from "./SelectCompanyProductAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports